import React from "react";
import Tooltip from "@mui/material/Tooltip";
import WarningIcon from "@mui/icons-material/Warning";
import { getLaborLawViolationLabel, getShiftLaborLawViolations } from "./shiftLaborLawWarnings";

export default function OpenShiftLaborLawWarning({ shift, violations, showActualTimes }) {
  const messages = getShiftLaborLawViolations(violations, [shift]).map(getLaborLawViolationLabel);
  if (showActualTimes || messages.length === 0) return null;

  return (
    <Tooltip title={messages.length === 1 ? messages[0] : (
      <ul className="list-disc pl-4">
        {messages.map((message, index) => <li key={`${message}-${index}`}>{message}</li>)}
      </ul>
    )}>
      <span tabIndex={0} role="img" aria-label={messages.join("; ")}
        className="ml-1 flex shrink-0 items-center">
        <WarningIcon sx={{ fontSize: "10px" }} />
      </span>
    </Tooltip>
  );
}
